module.exports = __webpack_public_path__ + "37b27f73768281801724c4cf3c49c991.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-Bold.woff2
// module id = 706
// module chunks = 0